module.exports = __webpack_public_path__ + "img/default-nav-subnav-lincoln.62adcf2f.png";